import type { useGetAssessmentActivitiesByParentId } from 'src/hooks/queries/assessment-activity/useGetAssessmentActivitiesByParentId';
import type { useGetAssessmentRCSAActivitiesByAssessmentId } from 'src/hooks/queries/assessment-activity/useGetAssessmentRCSAActivitiesByAssessmentId';
import type { LabelledIdArray } from 'src/rbac/types';

import type { CollectionData } from '@/utils/collectionUtils';

type GetAssessmentActivitiesByParentIdData = NonNullable<
  ReturnType<typeof useGetAssessmentActivitiesByParentId>['data']
>;

type GetAssessmentRCSAActivitiesByAssessmentIdData = NonNullable<
  ReturnType<typeof useGetAssessmentRCSAActivitiesByAssessmentId>['data']
>;

type DefaultFields = {
  StatusLabelled: string;
  ActivityTypeLabelled: string;
  CreatedById: string;
  CreatedByUsername: string;
  CreatedOn: string;
  UpdatedById: string;
  UpdatedByUsername: string;
};

export type AssessmentActivityFields = CollectionData<
  GetAssessmentActivitiesByParentIdData['assessment_activity'][number]
>;

export type AssessmentRCSAActivityFields = CollectionData<
  GetAssessmentRCSAActivitiesByAssessmentIdData['assessment_activity'][number]
>;

export type AssessmentActivityRegisterFields = AssessmentActivityFields &
  DefaultFields;

export type AssessmentRCSAActivityRegisterFields =
  AssessmentRCSAActivityFields &
    DefaultFields & {
      RiskSequentialId: null | string | undefined;
      LinkedRisk: null | string | undefined;
      allAssignedUsers: LabelledIdArray;
      LinkedRiskSequentialId: null | number | undefined;
      NextTestDate: string;
      NextTestOverdueDate: string;
    };

export type ActivityItemType = AssessmentActivityFields;
export type RCSAActivityItemType = AssessmentRCSAActivityFields;

export enum DeleteTypeEnum {
  Activity = 'activity',
  RCSA = 'rcsa',
}
